import { FC } from 'react';
import Modal from '../Modal/Modal';
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  isLoading?: boolean;
}

const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal.Wrapper isOpen={isOpen} onClose={onClose} closeable={!isLoading}>
      <div className="flex flex-col gap-4">
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        <p className="text-gray-600">{message}</p>
        
        <Modal.Nav>
          <div className="flex gap-3 justify-end w-full">
            <Button
              onClick={onClose}
              color="ghost"
              disabled={isLoading}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={onConfirm}
              color="error"
              disabled={isLoading}
              className={isLoading ? 'loading' : ''}
            >
              {isLoading ? t('Deleting...') : t('button.remove')}
            </Button>
          </div>
        </Modal.Nav>
      </div>
    </Modal.Wrapper>
  );
};

export default ConfirmDeleteModal;

